














































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import BannerDropdown from '../../components/BannerDropdown/index.vue'
import BannerTextInput from '../../components/BannerTextInput/index.vue'
import ImageUpload from '@/app/ui/components/ImageUpload/index.vue'
import BannerDatePicker from '../../components/BannerDatePicker/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import ConfirmationIcon from '@/app/ui/assets/icon_confirmation.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import dayjs from 'dayjs'
import {
  required,
  maxLength,
  url as urlValidation,
  or,
  and,
  between,
} from 'vuelidate/lib/validators'
import {
  EventBus,
  EventBusConstants,
  FormInterface,
  locationOptions,
  PopUpBannerForm,
  showTimeOptions,
  typeOptions,
} from '@/app/infrastructures/misc'
import controller from '@/app/ui/controllers/PopUpBannerController'

@Component({
  mixins: [validationMixin],
  components: {
    LoadingOverlay,
    BannerDropdown,
    BannerTextInput,
    ImageUpload,
    BannerDatePicker,
    Button,
    ConfirmationIcon,
    Modal,
  },
})
export default class PopUpBannerCreate extends Vue {
  MAX_SIZE = 5000
  confirmationModal = false
  isImageValid = false
  todayDate = dayjs().format('YYYY-MM-DD')
  form: FormInterface = {
    type: null,
    title: '',
    location: null,
    image: <File[] | Array<undefined>>[],
    url: '',
    timer: 3,
    showTime: null,
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
  }
  hasChanged = {
    type: false,
    title: false,
    location: false,
    image: false,
    url: false,
    timer: false,
    showTime: false,
    startDate: false,
    endDate: false,
    startTime: false,
    endTime: false,
  }
  typeOptions = typeOptions
  locationOptions = locationOptions
  showTimeOptions = showTimeOptions
  controller = controller

  @Validations()
  validations(): Record<string, unknown> {
    return {
      form: {
        type: {
          required,
        },
        title: {
          required,
          maxLength: maxLength(70),
        },
        location: {
          required,
        },
        url: {
          url: and(
            required,
            or(urlValidation, (value: string) =>
              value.startsWith('lionparcel://app')
            )
          ),
        },
        timer: {
          required,
          between: between(3, 10),
        },
        showTime: {
          required,
        },
        startDate: {
          required,
        },
        endDate: {
          required,
        },
        startTime: {
          required,
        },
        endTime: {
          required,
        },
      },
    }
  }

  created(): void {
    EventBus.$on(EventBusConstants.CREATE_POPUP_BANNER_SUCCESS, () => {
      this.$router.push({ name: `PopUpBanner` })
    })
  }

  private onFileChange($event: File): void {
    this.hasChanged.image = true
    this.form.image?.splice(0, 1, $event)
    if ($event) {
      this.isImageValid = true
    } else {
      this.isImageValid = false
    }
  }

  private onRemoveImage(index: number): void {
    this.form.image?.splice(index, 1)
  }

  private onCreateBanner(): void {
    if (!this.$v.form.$invalid && this.isImageValid && this.form.image[0]) {
      this.confirmationModal = false
      const payload: PopUpBannerForm = {
        type: this.form.type?.value,
        title: this.form.title,
        location: this.form.location?.value,
        image: this.form.image[0],
        url: this.form.url,
        timer: this.form.timer,
        showTime: this.form.showTime?.value,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
      }
      controller.createPopUpBanner(payload)
    } else {
      Vue.notify({
        title: 'Create Pop Up Banner',
        text: 'Please check every invalid form',
        type: 'error',
        duration: 5000,
      })
    }
    this.hasChanged = {
      type: true,
      title: true,
      location: true,
      image: true,
      url: true,
      timer: true,
      showTime: true,
      startDate: true,
      endDate: true,
      startTime: true,
      endTime: true,
    }
  }

  private isStartDateMoreEndDate(): void {
    this.hasChanged.startDate = true
    if (this.form.startDate > this.form.endDate) {
      this.form.endDate = ''
    }
  }

  private isStartTimeMoreEndTime(
    type: 'startTime' | 'endTime' = 'startTime'
  ): void {
    this.hasChanged[type] = true
    if (
      this.form.startDate === this.form.endDate &&
      this.form.startTime >= this.form.endTime
    ) {
      this.form.endTime = ''
    }
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.CREATE_POPUP_BANNER_SUCCESS)
  }
}
